import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { fmtBucketLabel } from "../../lib/dashboardDates";
import { fmtMoney } from "../../lib/format";

function TrendTooltip({ active, payload, label }) {
  const { t } = useTranslation();
  if (!active || !payload?.length) return null;
  const p = payload[0].payload;
  return (
    <div className="qw-tooltip">
      <div className="t-label">{label}</div>
      <div className="t-row">
        <span>{t("dashboard.trend_tooltip_value")}</span>
        <strong>{fmtMoney(p.accepted_value, "EUR")}</strong>
      </div>
      <div className="t-row">
        <span>{t("dashboard.trend_tooltip_count")}</span>
        <strong>{p.accepted_count}</strong>
      </div>
    </div>
  );
}

const compactBg = new Intl.NumberFormat("bg-BG", { notation: "compact", maximumFractionDigits: 1 });

export default function DashboardAcceptedTrend({ data, bucket, onBarClick }) {
  const { t } = useTranslation();
  const chartData = useMemo(
    () =>
      (data || []).map((p) => ({
        ...p,
        label: fmtBucketLabel(p.period_start, bucket),
      })),
    [data, bucket],
  );

  if (!chartData.length) {
    return (
      <div className="qw-empty" data-testid="trend-empty">
        {t("dashboard.trend_empty")}
      </div>
    );
  }

  return (
    <div className="qw-chart-container" data-testid="dashboard-trend-chart">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={chartData} margin={{ top: 8, right: 12, left: 8, bottom: 8 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
          <XAxis dataKey="label" tickLine={false} axisLine={false} />
          <YAxis
            tickLine={false}
            axisLine={false}
            width={72}
            tickFormatter={(v) => compactBg.format(v)}
          />
          <Tooltip content={<TrendTooltip />} cursor={{ fill: "rgba(15,118,110,0.06)" }} />
          <Bar
            dataKey="accepted_value"
            fill="#0f766e"
            radius={[6, 6, 0, 0]}
            onClick={(entry) => onBarClick(entry?.payload || entry)}
            cursor="pointer"
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
